import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
	emailSchedulerControllerSetEndDateMutation,
	emailSchedulerControllerListSchedulesQueryKey,
} from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import type { UseSetScheduledEmailEndDateArgs } from './useSetScheduledEmailEndDate.types';

export const useSetScheduledEmailEndDate = ({
	dealId,
	programmeId,
	onSettled,
}: UseSetScheduledEmailEndDateArgs) => {
	const tMipManage = useTranslationMipManage();
	const queryClient = useQueryClient();

	const setEndDateMutation = useMutation({
		...emailSchedulerControllerSetEndDateMutation(),
		onSuccess: async () => {
			showToastV2({
				title: tMipManage('email_scheduler.toast.end_date.successful'),
				state: 'success',
			});
			await queryClient.invalidateQueries({
				queryKey: emailSchedulerControllerListSchedulesQueryKey({
					path: { dealId, programmeId },
				}),
			});
		},
		onError: () => {
			showToastV2({
				state: 'error',
				title: tMipManage('email_scheduler.toast.end_date.error'),
			});
		},
		onSettled,
	});

	return {
		setEndDate: (id: string, endDate: string | null) =>
			setEndDateMutation.mutate({ path: { dealId, programmeId, id }, body: { endDate } }),
		isPending: setEndDateMutation.isPending,
	};
};
